<template>
    <div>
        <div v-for="entry in fileList" class="media-list-item">
            <div class="media-thumb-container">
                <div class="thumb-wrapper">
                    <img :src="entry.thumbPath" class="media-thumb" />
                    <span class="file-message">{{ entry.fileMsg }}</span>
                </div>
            </div>
            <div class="media-content-container">
                <div>
                    <textarea class="form-control content-textarea" v-model="entry.textContent" :placeholder="lang.common.content"></textarea>
                </div>
                <div class="action-buttons">
                    <button v-on:click="$emit('removeclicked', entry)" class="btn btn-danger btn-sm">{{lang.common.delete}}</button>
                    <button class="btn btn-primary btn-sm" v-on:click="$emit('updateclicked', entry)">{{ lang.common.update }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.media-list-item {
    background: white;
    display: flex;
    flex-flow: row;
    width: 100%;
    margin-bottom: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 10px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.media-thumb-container {
    width: 150px;
    flex-shrink: 0;
    margin-right: 15px;
}

.thumb-wrapper {
    width: 100%;
    overflow: hidden;
    text-align: center;
}

.media-thumb {
    width: 100%;
    height: 100px;
    object-fit: cover;
    border-radius: 3px;
    margin-bottom: 5px;
}

.file-message {
    display: block;
    font-size: 12px;
    color: #777;
    margin-top: 5px;
}

.media-content-container {
    flex: 1;
    padding: 0;
}

.content-textarea {
    min-height: 80px;
    margin-bottom: 10px;
    resize: vertical;
}

.action-buttons {
    text-align: right;
}

.action-buttons .btn {
    margin-left: 5px;
}
</style>
<script>
export default {
    props: {
        files: Array
    },
    computed: {
        lang: function () {
            return this.$store.getters.lang;
        },
        fileList: function () {
            return this.files;
        }
    },
    methods: {
    }
}
</script>